import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import Load from "../../assest/images/Load.png";
import Box from "@mui/material/Box";

const LoadingSpinner = ({ text = "TAKECARE" }) => {
  const [characters, setCharacters] = useState([]);

  useEffect(() => {
    setCharacters(text.split(""));
  }, [text]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(1px)",
        // backgroundColor: 'rgba(255, 255, 255, 0.2)',
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: 1300,
      }}
    >
      <div className="h-screen flex items-center justify-center">
        <h1 className="font-mono font-bold text-[clamp(3rem,13vw,10rem)] uppercase flex relative overflow-hidden items-center">
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <div style={{ width: "50px", height: "50px" }}>
              <motion.img
                src={Load}
                alt="Logo"
                style={{ width: "100%" }}
                // className="h-10 w-10 mr-4"
                // initial={{ y: '-100%', opacity: 0 }}
                animate={{
                  // y: ['-100%', '0%', '0%', '100%'],
                  opacity: [0, 1, 1, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "linear",
                  delay: 0,
                }}
              />
            </div>
            <div style={{ paddingleft: "2%" }}>
              {characters.map((char, index) => (
                <motion.span
                  key={index}
                  initial={{ y: "-100%", opacity: 0 }}
                  animate={{
                    y: ["-100%", "0%", "0%", "100%"],
                    opacity: [0, 1, 1, 0],
                    // color: '#130175',
                    color: "#c40001",
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "linear",
                    delay: index * 0.2,
                  }}
                  style={{ marginleft: "10px" }}
                  className="inline-block"
                >
                  {char}
                </motion.span>
              ))}
            </div>
          </div>
        </h1>
      </div>
    </Box>
  );
};

export default LoadingSpinner;
